<template>
  <div class="dhr-common-info">
    <div v-if="data && (data.bonID || data.lotID)" class="info-cell cell-xsm">
      <label>{{ data.bonID == "" ? "LOT no" : "Batch no" }}</label>
      <span>{{ data.bonID == "" ? data.lotID : data.bonID }}</span>
    </div>
    <div v-else class="info-cell cell-xsm">
      <label>Batch/LOT</label>
      <span>-</span>
    </div>
    <div v-if="data && data.snummer" class="info-cell cell-sm">
      <label>Lot no</label>
      <span>{{ data.snummer }}</span>
    </div>
    <div class="info-cell cell-sm">
      <label>REF</label>
      <span v-if="data && data.DHRREF">{{ data.DHRREF.substr(0, (data.DHRREF.lastIndexOf('-'))) }}</span>
      <span v-else>-</span>
    </div>
    <div class="info-cell cell-sm" v-if="data.bonID">
      <label>Material number</label>
      <span v-if="data && data.matNumber">{{ data.matNumber }}</span>
      <span v-else>-</span>
    </div>
    <div class="info-cell cell-sm">
      <label>Start Quantity</label>
      <span v-if="data && data.amount">{{ data.amount }}</span>
      <span v-else>-</span>
    </div>
    <div class="info-cell cell-xmd">
      <label>Final Quantity</label>
      <span v-if="data && data.finalAmount">{{ data.finalAmount }}</span>
      <span v-else>-</span>
    </div>
    <div class="info-cell cell-xmd">
      <label>Operator</label>
      <span v-if="data && data.firstName">{{ data.firstName + ' ' + data.lastName}}</span>
      <span v-else>-</span>
    </div>
    <div class="info-cell cell-sm">
      <label>Startdate</label>
      <span v-if="data && data.dateCreated">{{ data.dateCreated | formatDate }}</span>
      <span v-else>-</span>
    </div>
    <div class="info-cell cell-big">
      <label>DHR Version</label>
      <span v-if="data && data.editDate">{{ data.editDate | formatDate }}</span>
      <span v-else>-</span>
    </div>
    <div class="info-cell cell-xl">
      <span
        v-if="data && data.created == 1 && data.finished == 0 && isApproved == 0"
        class="status-card in-progress"
      >In Progress</span>
      <span
        v-if="data && data.finished == 1 && data.approved == 0"
        class="status-card completed"
      >Created</span>
      <span v-if="data && data.approved == 1" class="status-card approved">Approved</span>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    data: Object,
    isApproved: Boolean
  },
  data() {
    return {
      isLoaded: false
    };
  },
  methods: {},
  watch: {
    data: {
      handler: function() {
        this.isLoaded = true;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/base.scss";
@import "@/style/pages/dhrdetail.scss";
</style>
